import { DEAL_OPTIONS_INCLUSIONS_CATEGORY } from '../../checklistCategories';
import type { ApprovalQueueItem } from '../../types';

import type { DealOptionInclusionRowView, DealOptionRowView } from './types';

export function buildDealOptionsInclusionsQueueItem(row: DealOptionInclusionRowView): ApprovalQueueItem {
  return {
    categoryId: DEAL_OPTIONS_INCLUSIONS_CATEGORY.id,
    categoryLabel: DEAL_OPTIONS_INCLUSIONS_CATEGORY.label,
    description: `${row.dealOptionName} — ${row.name || 'Inclusion'} RRP mismatch requires review.`,
    details: [
      { label: 'Deal Option', value: row.dealOptionName },
      { label: 'Room', value: row.roomName },
      { label: 'Inclusion', value: row.name },
      {
        label: 'Deal Option Inclusion RRP',
        value: row.dealOptionInclusionRrp != null ? String(row.dealOptionInclusionRrp) : 'N/A',
      },
      {
        label: 'Inclusion Asset Value',
        value: row.inclusionAssetValue != null ? String(row.inclusionAssetValue) : 'N/A',
      },
    ],
    id: row.id,
    title: row.name || row.dealOptionName,
  };
}

export function getDealOptionsInclusionsSearchText(row: DealOptionInclusionRowView) {
  return [row.dealOptionName, row.name, row.description, row.type, row.roomName, row.statusLabel]
    .filter(Boolean)
    .join(' ');
}

export function getDealSearchText(deal: DealOptionRowView) {
  return [deal.dealOptionName, deal.roomName, deal.statusLabel].filter(Boolean).join(' ');
}
